import React, { useState, useEffect } from "react";

const TARGET = new Date("2026-03-31T23:59:59");

function pad(n) { return String(n).padStart(2, "0"); }

export default function CountdownTimer() {
  const [time, setTime] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const tick = () => {
      const diff = Math.max(0, TARGET - Date.now());
      setTime({
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff % 86400000) / 3600000),
        minutes: Math.floor((diff % 3600000) / 60000),
        seconds: Math.floor((diff % 60000) / 1000),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    { label: "ימים", value: time.days },
    { label: "שעות", value: time.hours },
    { label: "דקות", value: time.minutes },
    { label: "שניות", value: time.seconds },
  ];

  return (
    <div className="flex items-center gap-2 md:gap-4 justify-center" dir="ltr">
      {units.map(({ label, value }, i) => (
        <React.Fragment key={label}>
          <div className="flex flex-col items-center">
            <div
              className="w-16 h-16 md:w-20 md:h-20 rounded-2xl flex items-center justify-center font-bold relative overflow-hidden"
              style={{
                background: "linear-gradient(180deg, #0F0F0F 0%, #363636 48%, #111111 48.1%, #282828 100%)",
                border: "1px solid #626262",
                borderRadius: "16px",
              }}
            >
              <span style={{ color: "#BEBEBE", fontSize: "clamp(1.6rem, 3vw, 2.8rem)", fontFamily: "'IBM Plex Sans Hebrew', sans-serif", fontWeight: 700 }}>
                {pad(value)}
              </span>
            </div>
            <span className="text-[10px] font-black uppercase tracking-widest mt-2" style={{ color: "#BEBEBE", letterSpacing: "1.2px" }}>
              {label}
            </span>
          </div>
          {i < 3 && (
            <span className="font-bold text-2xl pb-5" style={{ color: "#BEBEBE" }}>:</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}